import React, { useState } from 'react';
import { FaClock, FaPlaneArrival, FaPlaneDeparture } from 'react-icons/fa';
import { MdAirplanemodeActive } from 'react-icons/md';
import moment from 'moment';
import 'moment/locale/ru';
import tourvisorAPI from '../../widgets/api/tourvisorAPI';
import FlightSegment from './FlightSegment';
import ProgressBar from '../../widgets/SearchTourForm/components/ProgressBar';

const FlightsClock = ({ tour_id }) => {
  const [errorInfo, setErrorInfo] = useState(false);
  const [flights, setFlights] = useState(null);
  const [error, setError] = useState('');
  const [isFlightsInfoLoading, setFlightsInfoLoading] = useState(false);
  const noFlightDataError = 'Нет данных о перелете';

  const getFlights = async () => {
    setFlightsInfoLoading(true);
    const data = await tourvisorAPI.actualize(tour_id);

    if (!data.iserror && data.flights[0].forward[0].company) {
      setFlights(data.flights[0]);
      setFlightsInfoLoading(false);
    } else {
      setErrorInfo(true);
      setError(noFlightDataError);
      setFlightsInfoLoading(false);
      console.log(noFlightDataError);
    }
  };
  moment.locale('ru');

  return (
    <>
      {isFlightsInfoLoading ? (
        <div className="flight-info__popup flight-info__popup_loading">
          <ProgressBar />
        </div>
      ) : null}
      {errorInfo ? (
        <div className="flight-info__popup">
          <div
            className="popup__close"
            onClick={() => {
              setErrorInfo(false);
              setError('');
            }}
          >
            ✖
          </div>
          <div className="flights__error">{error}</div>
        </div>
      ) : null}
      {flights ? (
        <div className="flight-info__popup">
          <div
            className="popup__close"
            onClick={() => {
              setFlights(false);
              setError('');
            }}
          >
            ✖
          </div>
          <div className="flights__container">
            {flights ? (
              <>
                <div className="flights__forward">
                  <div className="flights__icons">
                    <MdAirplanemodeActive
                      style={{ transform: 'rotate(90deg)', fontSize: 20 }}
                    />
                    <FaPlaneDeparture className='flights__icons-desktop' />
                    <FaPlaneArrival className='flights__icons-desktop' />
                  </div>
                  {flights.forward.map((flight) => {
                    return <FlightSegment key={flight.number + flight.departure.date} flight={flight} />;
                  })}
                </div>
                <div className="flights__backward">
                  <div className="flights__icons">
                    <MdAirplanemodeActive
                      style={{ transform: 'rotate(-90deg)', fontSize: 20 }}
                    />
                    <FaPlaneDeparture className='flights__icons-desktop' />
                    <FaPlaneArrival className='flights__icons-desktop' />
                  </div>
                  {flights.backward.map((flight) => {
                    return <FlightSegment key={flight.number + flight.departure.date} flight={flight} />;
                  })}
                </div>
              </>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="flight-clock" onClick={getFlights}>
          <FaClock />
        </div>
      )}
    </>
  );
};

export default FlightsClock;
